import * as yup from "yup"
import { parse, isDate } from "date-fns"

yup.setLocale({
	mixed: {
		default: 'Campo inválido',
		required: 'Campo requerido',
		notType: params => 'El valor ingresado no es válido'
	},
	string: {
		length: params => `El campo debe tener ${params.length} caracteres`,
		max: params => `El campo no debe superar los ${params.max} caracteres`,
		min: params => `El campo no debe tener menos de ${params.min} caracteres`
	}
})

yup.addMethod(yup.date, 'format', function (format = "dd/MM/yyyy") {
	return this.transform((value, originalValue) => {
		const parsedDate = isDate(originalValue)
			? originalValue
			: parse(originalValue, format, new Date())

		return parsedDate
	})
})

export default yup